import { useCallback } from 'react'
import {
  IUserPreferenceGeneralListItemType,
  saveGeneralPreferencesBatch,
} from '@user/store/userPreferences/userPreferencesGeneral'
import { useAppDispatch } from '@user/store/hooks'
import { logger } from '@user/utils/logger'
import { ChipItem } from '../types'
import { PREF } from '../constants'
import { closeMapBubbles } from '../utils'

type Params = {
  hereMap: H.Map | undefined
  selectedTypes: string[]
  selectedKnockStatusIds: string[]
  onOpenFilterDrawer?: () => void
}

export function useHandlers({
  hereMap,
  selectedTypes,
  selectedKnockStatusIds,
  onOpenFilterDrawer,
}: Params) {
  const dispatch = useAppDispatch()

  const removeActiveBubble = useCallback(() => {
    if (!hereMap) return
    try {
      closeMapBubbles(hereMap)
    } catch (err) {
      logger.error('Failed to remove active bubbles:', err)
    }
  }, [hereMap])

  const savePreference = useCallback(
    (type: IUserPreferenceGeneralListItemType, value: string) => {
      removeActiveBubble()
      dispatch(saveGeneralPreferencesBatch([{ type, value }]))
    },
    [dispatch, removeActiveBubble],
  )

  const handleChipDelete = useCallback(
    (chip: ChipItem) => {
      switch (chip.type) {
        case 'myRecords':
          savePreference(PREF.myRecords, 'false')
          return
        case 'recordType': {
          if (!chip.id) return
          const next = selectedTypes
            .filter((t) => t && t.trim() !== '' && t !== chip.id)
            .join('_')
          savePreference(PREF.entityTypes, next)
          return
        }
        case 'knockStatus': {
          if (!chip.id) return
          const next = selectedKnockStatusIds.filter(
            (id) => id && id.trim() !== '' && id !== chip.id,
          )
          savePreference(
            PREF.knockStatuses,
            next.length > 0 ? next.join('_') : 'none',
          )
          return
        }
      }
    },
    [savePreference, selectedTypes, selectedKnockStatusIds],
  )

  const handleOverflowChipClick = useCallback(() => {
    onOpenFilterDrawer?.()
  }, [onOpenFilterDrawer])

  return {
    handleChipDelete,
    handleOverflowChipClick,
  }
}
